import { Component, OnInit, OnDestroy } from '@angular/core';
import { CardService }            from '@omnipas/services/card.service';
import { DataService }            from '@omnilib/services/data.service';
import { DeliveryAddressService } from '@omnipas/services/deliveryaddress.service';
import { EnvironmentService }     from '@omnipas/services/environment.service';
import { ListService }            from '@omnilib/services/list.service';
import { LoadingService }         from '@omnipas/services/loading.service';
import { MessageService }         from '@omnipas/services/message.service';
import { PageHeaderService }      from '@omnipas/services/pageheader.service';
import { RouterService }          from '@omnipas/services/router.service';
import { PhotoService } from '@omnipas/services/photo.service';

@Component({
  selector: 'omnipas-deliveryaddress2',
  templateUrl: './deliveryaddress2.component.html'
})
export class DeliveryAddress2Component implements OnInit, OnDestroy {

  initialized:       boolean = false;

  postalcode:        string = '';
  housenumber:       string = '';
  housenumbersuffix: string = '';
  street:            string = '';
  city:              string = '';

  existingAddressLine1: string = '';
  existingAddressLine2: string = '';

  newAddressLine1: string = '';
  newAddressLine2: string = '';

  change:            boolean = false;
  addressfound:      boolean = false;
  saved:             boolean = false;
  searching:         boolean = false;
  showLogout:        boolean = false;

  constructor ( public card:            CardService
              , public data:            DataService
              , public deliveryaddress: DeliveryAddressService
              , public environment:     EnvironmentService
              , public list:            ListService
              , public loading:         LoadingService
              , public message:         MessageService
              , public pageheader:      PageHeaderService
              , public router:          RouterService
              , public photo:           PhotoService
              ) {
  }

  async ngOnInit() {

    this.router.toggleshowwait( true );

    this.initialized = false;

    if ( this.list.emptyList( this.router.persondata ) ) {
      this.router.logout();
    } else {
      this.pageheader.setPageHeader( 'pagetitle.deliveryaddress', 'pagetitle.deliveryaddress' );
    }

    // Format the existing address from the person call into two display lines.
    // For a postadres the fields are combined: 'street' holds street + housenumber,
    // 'city' holds postalcode + city, and number/suffix/postalCode are empty. The
    // filter/join below drops the empty parts so both cases format cleanly.
    let street     = this.list.getValue( this.router.persondata, 'street',     true ) || '';
    let number     = this.list.getValue( this.router.persondata, 'number',     true ) || '';
    let suffix     = this.list.getValue( this.router.persondata, 'suffix',     true ) || '';
    let postalcode = this.list.getValue( this.router.persondata, 'postalCode', true ) || '';
    let city       = this.list.getValue( this.router.persondata, 'city',       true ) || '';

    this.existingAddressLine1 = [ street, number, suffix ].filter( v => v ).join( ' ' );
    this.existingAddressLine2 = [ postalcode, city ].filter( v => v ).join( ' ' );

    this.initialized = true;

    this.router.toggleshowwait( false );
  }

  logout() {
    this.router.logout();
  }

  toggleChange() {
    this.pageheader.setPageHeader( 'pagetitle.deliveryaddress', 'deliveryaddress.line5' );
    this.change = true;
  }

  formatZipCode() {
    this.postalcode = this.postalcode.toUpperCase();

    if ( this.postalcode.length == 4 ) {
      this.postalcode = this.postalcode + ' ';
      return;
    }

    if ( this.postalcode.length == 6 ) {
      if ( this.postalcode.charAt(4) != ' ' ) {
        this.postalcode = this.postalcode.substring(0,4) + ' ' + this.postalcode.substring(4);
      }
    }

    if ( this.postalcode.length != 7 || this.housenumber.length == 0  ) {
      this.street       = '';
      this.city         = '';
      this.addressfound = false;
      return;
    }
  }

  async searchAddress() {
    if ( this.postalcode.length != 7 || this.housenumber.length == 0  ) {
      this.street       = '';
      this.city         = '';
      this.addressfound = false;
      this.searching    = false;
      return;
    }

    this.router.toggleshowwait( true );

    this.searching = true;

    let result = await this.data.getpc( this.postalcode.replace(' ', ''), this.housenumber );

    if ( result != null && result['result']['code'] && result['result']['code'] == '0' && !this.list.emptyList( result['result']['resultset'] ) ) {
      this.street       = this.list.getValue( result['result']['resultset'], 'street', true );
      this.city         = this.list.getValue ( result['result']['resultset'], 'city', true );
      this.addressfound = true;
    } else  {
      this.addressfound = false;
    }

    this.searching = false;
    this.router.toggleshowwait( false );
  }

  enableSubmit() {
    return this.street == '' || this.housenumber == '' || this.postalcode == '' || this.city == '' ? 'disabled' : '';
  }

  async agree() {
    this.router.toggleshowwait( true );

    if ( !this.photo.firstphoto && !this.list.emptyList ( this.environment.getEnvValue('cardprices') ) && this.router.amount != '0000' ) {
      this.router.goTo("payment");
    } else {
      if ( await this.card.create() ) {
        this.showLogout = true;
        this.message.setSuccessMessage ( 'requestcard.success' );
      } else {
        this.message.setErrorMessage( 'requestcard.failure' );
      }
    }

    this.router.toggleshowwait( false );
  }

  async submit() {
    this.router.toggleshowwait( true );

    this.deliveryaddress.addressLine1 = ( this.street + ' ' + this.housenumber + ' ' + this.housenumbersuffix ).trim();
    this.deliveryaddress.addressLine2 = this.postalcode + '  ' + this.city;

    this.newAddressLine1 = ( this.street + ' ' + this.housenumber + ' ' + this.housenumbersuffix ).trim();
    this.newAddressLine2 = this.postalcode + '  ' + this.city;
    
    if(this.router.transparams.customer_shortname != 'HVA' && this.router.transparams.customer_shortname != 'UVA'){
      if ( await this.deliveryaddress.update(this.street, this.housenumber, this.housenumbersuffix, this.postalcode, this.city, "", "") ) {
        if ( !this.photo.firstphoto && !this.list.emptyList ( this.environment.getEnvValue('cardprices') ) && this.router.amount != '0000' ) {
          this.router.goTo("payment");
        } else {
          if ( await this.card.create() ) {
            this.showLogout = true;
            this.message.setSuccessMessage ( 'requestcard.success');
          } else {
            this.message.setErrorMessage( 'requestcard.failure' );
          }
        }
      } else {
        this.message.setErrorMessage('deliveryaddress.failure');
      }
    } else {
      if ( await this.deliveryaddress.updateFreeField() ) {
        if ( !this.photo.firstphoto && !this.list.emptyList ( this.environment.getEnvValue('cardprices') ) && this.router.amount != '0000' ) {
          this.router.goTo("payment");
        } else {
          if ( await this.card.create() ) {
            this.showLogout = true;
            this.message.setSuccessMessage ( 'deliveryaddress.success');
          } else {
            this.message.setErrorMessage( 'requestcard.failure' );
          }
        }
      } else {
        this.message.setErrorMessage('deliveryaddress.failure');
      }
    }

    this.router.toggleshowwait( false );
  }

  back() {
    this.postalcode        = '';
    this.housenumber       = '';
    this.housenumbersuffix = '';
    this.street            = '';
    this.city              = '';

    this.change            = false;
    this.addressfound      = false;
    this.saved             = false;
    this.searching         = false;
    this.message.error     = false;
  }

  cancel() {
    this.router.goHome();
  }

  ngOnDestroy() {
    return;
  }

}
